/* import __COLOCATED_TEMPLATE__ from './payee-verification-widget.hbs'; */
import Component from '@ember/component';
import { showModal } from "sh-www/utils/modal-controls";

const CLASS_NAME = 'SH-c-payout-payee-verification-widget';
const CONTAINER_ID = 'hyperwallet-drop-in--payee-verification';

export default Component.extend({
  tagName: '',
  CLASS_NAME,
  CONTAINER_ID,

  /** @param {HyperwalletUser} */
  hyperwalletUser: null,

  /** @param {String} */
  scriptHost: '',

  /** @param {Function} */
  getAuthToken: () => {},

  /** @param {Function} */
  onSubmitSuccess: () => {},

  /** @type {Boolean} */
  isLoadingWidget: true,

  /** @type {Boolean} */
  isSubmittingData: false,

  /** @type {Boolean} */
  isTransitioningAway: false,

  /** @type {Function} */
  removeScript: () => {},

  /** @type {Boolean} */
  isScriptRemoved: false,

  didInsertElement() {
    this._super(...arguments);

    const retrieveAuthenticationToken = (callback) => {
      this.get('getAuthToken')().then((authToken) => {
        callback(authToken);
      });
    };

    const configureWidget = () => {
      const options = {
        el: document.getElementById(CONTAINER_ID),
      };

      HWWidgets.users.configure(options).display();

      HWWidgets.events.on('widget:loading:shown', () => {
        if (this.get('isScriptRemoved')) return;
        if (this.get('isLoadingWidget')) return;

        this.set('isSubmittingData', true);
      });

      HWWidgets.events.on('widget:loading:hidden', () => {
        if (this.get('isScriptRemoved')) return;

        this.set('isLoadingWidget', false);

        if (!this.get('isSubmittingData')) return;

        this.set('isSubmittingData', false);
      });

      HWWidgets.events.on('widget:users:completed', () => {
        if (this.get('isScriptRemoved')) return;

        this.set('isTransitioningAway', true);
        this.get('onSubmitSuccess')();
      });
    };

    const hyperwalletScript = document.createElement('script');

    hyperwalletScript.onload = () => {
      if (this.get('isScriptRemoved')) return;

      HWWidgets.initialize((onSuccess) => {
        retrieveAuthenticationToken((authToken) => {
          onSuccess(authToken);
        });
      });

      configureWidget();
    };

    hyperwalletScript.onerror = () => {
      if (this.get('isScriptRemoved')) return;

      this.set('isLoadingWidget', false);

      showModal(this, 'confirmation', {
        titleText: 'An error occurred',
        bodyText: 'Failed to connect to the payment system. Please try again later and contact support if the issue persists.',
        actionButtonText: 'Ok',
      });
    };

    const host = this.get('scriptHost');
    const token = this.get('hyperwalletUser.token');
    hyperwalletScript.src = `https://${host}/rest/widgets/users/${token}/en.v2_3_0.min.js`;

    document.head.appendChild(hyperwalletScript);

    this.set('removeScript', () => {
      hyperwalletScript.remove();
      this.set('isScriptRemoved', true);
    });
  },

  willDestroyElement() {
    this._super(...arguments);

    this.get('removeScript')();
  },
});
